
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { HomeService } from './services/home.service';
import {Title} from "@angular/platform-browser";
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { TranslateCompiler, TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './services/analytics.service';
import { ConfigService } from './services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  networkOk = true;

  constructor(
    private homeService: HomeService,
    private titleService: Title, 
    public router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private translate: TranslateService,
    private configService: ConfigService,
    private analyticsService: AnalyticsService
    ) {

    this.networkOk = true;

    this.homeService
      .getParameterPipe('TitleEng')
      .pipe(
      switchMap(async (res: any) => {
        switch (res.status) {
        case 200:
          this.titleService.setTitle(res.body[0].VALUE);
        }
      }),
      catchError((e) => {
        this.titleService.setTitle('OPAC...');
        return of({});
      })
      )
      .subscribe();

    }

  async ngOnInit(): Promise<void> {
    const lang  = localStorage.getItem('lang');
    if(!lang){
      this.homeService
      .getParameterPipe('LanguageCode')
      .pipe(
        switchMap(async (res: any) => {
          switch (res.status) {
            case 200:
              this.networkOk =true
              if (res.body.length == 1) {
                if (res.body[0].VALUE === 'en-GB') {
                  localStorage.setItem('lang', 'en');
                  this.translate.setDefaultLang(localStorage.getItem('lang'));
                } else{
                  localStorage.setItem('lang', 'th');
                  this.translate.setDefaultLang(localStorage.getItem('lang'));
                }
              } else{
                localStorage.setItem('lang', 'th');
                this.translate.setDefaultLang(localStorage.getItem('lang'));
              }
              break;
            default:
              break;
          }
        }),
        catchError((e) => {
          this.networkOk=false;
          return of({});
        })
      )
      .subscribe();
    }
    
    await this.configService.loadConfig();
    this.analyticsService.initGA();
        
  }

  onActivate(event) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    // let scrollToTop = window.setInterval(() => {
    //     let pos = window.pageYOffset;
    //     if (pos > 0) {
    //       window.scrollTo(0, pos - 100); // how far to scroll on each step
    //     } else {
    //         window.clearInterval(scrollToTop);
    //     }
    // }, 16);
  }


  ngOnDestroy(): void {
    const scriptElement = document.getElementById('cookieWow');
    if (scriptElement) {
      scriptElement.remove();
    }
  }


}
